import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossedFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.273 1 1 2.273 3.727 5c-2.522 1.16-3.1 3.584-2.52 8.5C2.188 21.813 3.537 23 12 23c4.178 0 6.622-.29 8.144-1.583l1.586 1.586 1.273-1.273zm5.554 8.1H5v1.8h4.627zm3.5 3.5H5.5v1.8h7v-.627z"
                    fill="currentColor"
                />
                <path
                    d="M6.3 2.48c1.6-.217 3.504-.28 5.7-.28 2.376 0 4.41.073 6.088.338.875.137 1.706.335 2.468.629C19.606 1.346 17.042 1 12 1c-3.014 0-5.142.124-6.57.612z"
                    fill="currentColor"
                />
                <path
                    d="M22.793 13.5c-.225 1.904-.469 3.434-.813 4.661L14.719 10.9H19V9.1h-6.081l-4.98-4.98C9.115 4.03 10.463 4 12 4c9.444 0 11.774 1.188 10.793 9.5"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CardLinesStackedCrossedFilledSize24Glyph.displayName = 'CardLinesStackedCrossedFilledSize24Glyph';
